import React, { Component } from 'react';
import Pagination from 'components/Pagination/Pagination';
import SearchUsersForm from 'components/SearchUsersForm';
import PurchaseList from 'components/PurchaseList/PurchaseList';
import UsersList from './UsersList';

const Checkbox = ({ value, onClick }) => {
  return (
    <input
      type="checkbox"
      className="checkbox"
      value={!!value}
      onClick={onClick}
    />
  );
};

const chooseErrorMessage = (error) => {
  const defaultError = 'Something went wrong';
  const err = (error && error.errors) || defaultError;

  return typeof err === 'string'
    ? err
    : err.status || err.detail || err.message;
};

const goToPurchase = (history, id) => {
  history.push(`/purchases/${id}/view`);
};

class MergePurchases extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedPurchases: {},
      isOtherUser: false,
      selectedUser: undefined,
      error: '',
      success: '',
    };

    this.userId = undefined;
  }

  fetchData = () => {
    const { findPurchase, match, page } = this.props;
    const { purchaseId } = match.params;

    findPurchase(purchaseId)
      .then((result) => {
        return result.user_profile;
      })
      .then((userId) => {
        this.userId = userId;
        return this._fetchUserPurchases(userId, page);
      });
  };

  _fetchUserPurchases = (id, page) => {
    return this.props
      .fetchUserPurchases(id, page, { status: ['pending', 'overdue'] })
      .catch((error) => {
        this.setState({
          error: chooseErrorMessage(error),
        });
      });
  };

  _fetchSpecificUserPurchases = (id, page) => {
    return this.props
      .fetchSpecificUserPurchases(id, page, { status: ['pending', 'overdue'] })
      .catch((error) => {
        this.setState({
          error: chooseErrorMessage(error),
        });
      });
  };

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(oldProps) {
    if (
      oldProps.match.params.purchaseId !== this.props.match.params.purchaseId
    ) {
      this.fetchData();
    }

    if (oldProps.page !== this.props.page) {
      this._fetchUserPurchases(this.userId, this.props.page);
    }

    const { selectedUser } = this.state;
    if (selectedUser && oldProps.otherUserPage !== this.props.otherUserPage) {
      this._fetchUserPurchases(selectedUser.id, this.props.otherUserPage);
    }
  }

  handleCheckPurchase = (id) => {
    this.setState((state) => ({
      checkedPurchases: {
        ...state.checkedPurchases,
        [id]: !state.checkedPurchases[id],
      },
    }));
  };

  toggleOtherUserView = () => {
    this.setState((state) => ({
      isOtherUser: !state.isOtherUser,
    }));
  };

  handleUserSelect = (user) => {
    const { otherUserPage = 1 } = this.props;
    this.setState({
      selectedUser: user,
    });
    this._fetchSpecificUserPurchases(user.id, otherUserPage);
  };

  handleMerge = () => {
    const { purchases, otherUserPurchases, mergePurchases, history, match } =
      this.props;
    const { selectedUser, checkedPurchases, isOtherUser } = this.state;
    const { purchaseId } = match.params;

    const purchaseIds = Object.entries(checkedPurchases).reduce(
      (acc, [key, value]) => {
        if (value) {
          acc.push(parseInt(key, 10));
        }
        return acc;
      },
      [],
    );

    if (!purchaseIds || !purchaseIds.length) {
      this.setState({
        error: 'Select purchases first',
      });
      return;
    }

    this.setState({
      error: '',
    });

    const isSelectedOtherUser = isOtherUser && selectedUser;

    const attrs = {
      others: purchaseIds.filter((id) => {
        return isSelectedOtherUser
          ? purchases.some(
              (p) => p.id === id || otherUserPurchases.some((p) => p.id === id),
            )
          : purchases.some((p) => p.id === id);
      }),
      other_user: isSelectedOtherUser ? selectedUser.id : undefined,
    };

    mergePurchases(this.props.match.params.purchaseId, attrs)
      .then(() => {
        this.setState({ success: 'Successfully merged' });
        setTimeout(() => {
          goToPurchase(history, purchaseId);
        }, 3000);
      })
      .catch((error) => {
        this.setState({
          error: chooseErrorMessage(error),
        });
      });
  };

  renderCheckbox = (purchase) => {
    const { id } = purchase;
    return (
      <Checkbox
        value={this.state.checkedPurchases[id]}
        onClick={() => this.handleCheckPurchase(id)}
      />
    );
  };

  render() {
    const {
      purchases,
      pageCount,
      page,
      match,
      searchUsers,
      users,
      otherUserPurchases,
      otherUserPageCount,
      otherUserPage,
    } = this.props;
    const { purchaseId } = match.params;
    const { selectedUser, isOtherUser, error, success } = this.state;
    return (
      <div>
        <h1>Merge Purchases</h1>
        <PurchaseList
          purchases={purchases.filter((p) => p.id.toString() !== purchaseId)}
          actionComponent={this.renderCheckbox}
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) => `/purchases/${purchaseId}/merge?page=${pageNum}`}
        />

        <div style={{ display: 'flex', fontSize: '16px' }}>
          <div className="mar-r">Include purchases from another user </div>
          <Checkbox value={isOtherUser} onClick={this.toggleOtherUserView} />
        </div>

        {isOtherUser && (
          <React.Fragment>
            <h3> Search user </h3>
            <SearchUsersForm
              onSubmit={(values) => searchUsers(1, values)}
              fields={['email', 'first_name', 'last_name']}
            />
            <UsersList
              users={users}
              selectedUser={selectedUser}
              handleUserSelect={this.handleUserSelect}
              mainUserId={this.userId}
            />
            {otherUserPurchases.length > 0 && (
              <React.Fragment>
                <h3>
                  {selectedUser.first_name} {selectedUser.last_name} purchases
                </h3>
                <PurchaseList
                  purchases={otherUserPurchases}
                  actionComponent={this.renderCheckbox}
                />
                <Pagination
                  count={otherUserPageCount}
                  current={otherUserPage}
                  url={(pageNum) =>
                    `/purchases/${purchaseId}/merge?otherUserPage=${pageNum}`
                  }
                />
              </React.Fragment>
            )}
          </React.Fragment>
        )}

        {error && <div className="mar-t text-danger">{error}</div>}

        {success && <div className="mar-t text-success">{success}</div>}

        <div className="mar-t">
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.handleMerge}
          >
            Merge
          </button>
        </div>
      </div>
    );
  }
}

export default MergePurchases;
